import { render, staticRenderFns } from "./PerfilSelect.vue?vue&type=template&id=7d0b2de6&"
import script from "./PerfilSelect.vue?vue&type=script&lang=js&"
export * from "./PerfilSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports